<script lang="ts">
	import { serializeSchema } from '$lib/utils/json-ld';
	import type { Schema } from '$lib/utils/json-ld';

	interface Props {
		schema: Schema;
	}

	let { schema }: Props = $props();
</script>

{@html serializeSchema(schema)}
